import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useDialogContext } from './dialog-context-provider';
import { ModalHeader, ModalHeaderProps } from '../modal/modal-header';

export type DialogHeaderProps = ModalHeaderProps;

export const DialogHeader = ({ className, ...props }: DialogHeaderProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-dialog__header');
  const { disableLegacy } = useDialogContext();
  useEffect(() => disableLegacy(), []);

  return <ModalHeader {...props} className={classNames} />;
};
